var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('index',{attrs:{"additional-route-params":_vm.additionalRouteParams,"breadcrumbs":_vm.breadcrumbs,"admin-view":"admin-component-knowledgecheck","header-text":"Component Knowledge Check","response-view":"client-component-knowledgecheck-response-show"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a1d1e93","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/client/knowledge-checks/component-index.vue
// module id = null
// module chunks = 